import React from "react";
import { ModalAllder } from "layouts/ModalAllder";
import InfoIcon from "@mui/icons-material/Info";
import { Button } from "@mui/material";

export function DefaultPackageModal({ modal, setModal, onConfirm }) {
  return (
    <ModalAllder modal={modal} setModal={setModal} htitle={""} hbtn={false}>
      <div className="py-4">
        <div className="">
          <div className="text-center mb-4">
            <InfoIcon className="!text-[100px] text-[#409FFB]" />
          </div>
          <div className="text-center text-2xl lh-base font-semibold text-[#4C4E64]/[0.87] mb-4">
            มีแพ็คเกจเริ่มต้นอยู่แล้ว
          </div>
          <div className="text-center text-lg text-[#4C4E64]/[0.87] mb-4">
            ต้องการเปลี่ยนแพ็คเกจเริ่มต้นใช่หรือไม่?
          </div>
          <div className="flex justify-center gap-4">
            <Button
              type="button"
              className="btn-st-5 !border-[#6D788D] !rounded-lg !text-[#6D788D]"
              variant="outlined"
              onClick={() => setModal({ ...modal, open: false })}
            >
              ยกเลิก
            </Button>
            <Button
              type="button"
              className="btn-st-5 !bg-[#409FFB] !rounded-lg !text-[#FFFFFF]"
              variant="contained"
              onClick={onConfirm}
            >
              ยืนยัน
            </Button>
          </div>
        </div>
      </div>
    </ModalAllder>
  );
}
